import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useSelectedSpacesEditorStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
    marginTop: tokens.spacingVerticalL,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    fontWeight: tokens.fontWeightSemibold,
    fontSize: fontScale.body,
  },
  badge: {
    fontSize: fontScale.caption,
  },
  card: {
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke1),
    borderRadius: tokens.borderRadiusMedium,
    overflow: 'hidden',
  },
  columnHeaders: {
    display: 'grid',
    gridTemplateColumns: '6fr 4fr auto',
    gap: tokens.spacingHorizontalS,
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalXS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    fontSize: fontScale.caption,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground3,
  },
  columnHeaderSpacer: {
    width: '32px',
  },
  spaceList: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '480px',
    overflowY: 'auto',
  },
  spaceRow: {
    display: 'grid',
    gridTemplateColumns: '6fr 4fr auto',
    gap: tokens.spacingHorizontalS,
    alignItems: 'center',
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
    borderTopColor: tokens.colorNeutralStroke2,
  },
  spaceInputRelative: {
    position: 'relative',
    minWidth: 0,
    width: '100%',
    overflow: 'hidden',
  },
  comboboxFull: {
    width: '100%',
    '& input': {
      paddingRight: '80px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  spaceListbox: {
    maxHeight: '21.75rem !important' as unknown as string,
  },
  spaceOptionGroupHeader: {
    paddingTop: '6px',
    paddingBottom: '6px',
    paddingLeft: '12px',
    paddingRight: '12px',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: tokens.colorNeutralStroke2,
  },
  spaceOptionGroupLabel: {
    fontSize: fontScale.caption,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground3,
  },
  spaceOptionContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: tokens.spacingHorizontalS,
  },
  spaceBadgeInline: {
    flexShrink: 0,
    fontSize: fontScale.caption,
    whiteSpace: 'nowrap',
  },
  badgeOverlay: {
    position: 'absolute',
    right: '8px',
    top: '50%',
    transform: 'translateY(-50%)',
    pointerEvents: 'none',
    fontSize: fontScale.caption,
    whiteSpace: 'nowrap',
  },
  removeButton: {
    color: tokens.colorPaletteRedForeground1,
    minWidth: '32px',
    ':hover': {
      color: tokens.colorPaletteRedForeground2,
    },
  },
  roomCapacityLabel: {
    gridColumn: '1 / -1',
    fontSize: fontScale.caption,
    color: tokens.colorNeutralForeground3,
    marginTop: '-4px',
    marginBottom: '-2px',
  },
  setupDropdown: {
    minWidth: 0,
    width: '100%',
    '& button': {
      minWidth: 0,
      maxWidth: '100%',
    },
  },
  setupValueText: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    minWidth: 0,
    flex: 1,
  },
  addButtonRow: {
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
    borderTopColor: tokens.colorNeutralStroke2,
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
  },
  addButton: {
    width: '100%',
    justifyContent: 'center',
  },
  summary: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
  },
  summaryLine: {
    fontSize: fontScale.caption,
    color: tokens.colorNeutralForeground3,
  },
  validationSuccess: {
    fontSize: fontScale.caption,
    color: tokens.colorPaletteGreenForeground1,
    backgroundColor: tokens.colorPaletteGreenBackground1,
    paddingTop: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalXS,
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
    borderRadius: tokens.borderRadiusMedium,
  },
  validationWarning: {
    fontSize: fontScale.caption,
    color: tokens.colorPaletteRedForeground1,
    backgroundColor: tokens.colorPaletteRedBackground1,
    paddingTop: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalXS,
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
    borderRadius: tokens.borderRadiusMedium,
  },
  calendarLink: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    fontSize: fontScale.caption,
    color: tokens.colorBrandForeground2,
    cursor: 'pointer',
    textDecorationLine: 'none',
    width: 'fit-content',
  },
});
